export default __webpack_public_path__ + "static/media/aboutImg.5654f87f.png";